module.exports = __webpack_public_path__ + "static/media/call.11335762.png";